import { invalidateKB } from '@/services/invalidateKB';
import { trpc } from '@/services/trpc';

export function useKBMutations() {
  const utils = trpc.useUtils();

  const invalidateKBAfterDelete = async () => {
    await Promise.all([
      utils.documentFolders.findAll.invalidate(),
      utils.documents.getStats.invalidate(),
      utils.chats.findAll.invalidate(),
      utils.chats.findOne.invalidate(),
    ]);
  };

  const createFolder = trpc.documentFolders.create.useMutation({
    onSuccess: invalidateKB,
  });

  const updateFolder = trpc.documentFolders.update.useMutation({
    onSuccess: invalidateKB,
  });

  const deleteFolder = trpc.documentFolders.delete.useMutation({
    onSuccess: invalidateKBAfterDelete,
  });

  const moveFolder = trpc.documentFolders.move.useMutation({
    onSuccess: invalidateKB,
  });

  const assignToChats = trpc.documentFolders.assignToChats.useMutation({
    onSuccess: invalidateKB,
  });

  const removeFromChat = trpc.documentFolders.removeFromChat.useMutation({
    onSuccess: invalidateKB,
  });

  const createWebsite = trpc.documentFolders.createWebsite.useMutation({
    onSuccess: invalidateKB,
  });

  const previewCrawl = trpc.documentFolders.previewWebsiteCrawl.useMutation();

  const triggerCrawl = trpc.documentFolders.triggerCrawl.useMutation({
    onSuccess: invalidateKB,
  });

  const promoteToTrackedWebsite =
    trpc.documentFolders.promoteToTrackedWebsite.useMutation({
      onSuccess: invalidateKB,
    });

  const includePages = trpc.documentFolders.includePages.useMutation({
    onSuccess: invalidateKB,
  });

  const dismissPages = trpc.documentFolders.dismissPages.useMutation({
    onSuccess: invalidateKB,
  });

  const deleteRemovedPages =
    trpc.documentFolders.deleteRemovedPages.useMutation({
      onSuccess: invalidateKB,
    });

  const excludePages = trpc.documentFolders.excludePages.useMutation({
    onSuccess: invalidateKB,
  });

  const bulkMove = trpc.documents.bulkMoveToFolder.useMutation({
    onSuccess: invalidateKB,
  });

  const bulkDelete = trpc.documents.bulkDelete.useMutation({
    onSuccess: invalidateKB,
  });

  const bulkAssign = trpc.documents.bulkAssignToChats.useMutation({
    onSuccess: invalidateKB,
  });

  const bulkAssignFoldersToChats =
    trpc.documentFolders.bulkAssignToChats.useMutation({
      onSuccess: invalidateKB,
    });

  const bulkUpdateDocumentsAutoUpdate =
    trpc.documents.bulkUpdateAutoUpdate.useMutation({
      onSuccess: invalidateKB,
    });

  const bulkUpdateFoldersAutoUpdate =
    trpc.documentFolders.bulkUpdateAutoUpdate.useMutation({
      onSuccess: invalidateKB,
    });

  const bulkRefresh = trpc.documents.bulkRefresh.useMutation({
    onSuccess: invalidateKB,
  });

  const bulkWeight = trpc.documents.bulkUpdateWeight.useMutation({
    onSuccess: invalidateKB,
  });

  return {
    createFolder,
    updateFolder,
    deleteFolder,
    moveFolder,
    assignToChats,
    removeFromChat,
    createWebsite,
    previewCrawl,
    triggerCrawl,
    promoteToTrackedWebsite,
    includePages,
    dismissPages,
    excludePages,
    deleteRemovedPages,
    bulkMove,
    bulkDelete,
    bulkAssign,
    bulkAssignFoldersToChats,
    bulkUpdateDocumentsAutoUpdate,
    bulkUpdateFoldersAutoUpdate,
    bulkRefresh,
    bulkWeight,
  };
}
